/**
 * What counts as a click beside the widget bar (#1822). Panel and gallery belong
 * to it, and the taskbar buttons toggle it themselves. An open modal dialog
 * (editor, share) is opened from the bar, and a click there stays with it. Only
 * Radix dialogs carry data-state; desktop windows are role=dialog too and do
 * count as outside.
 */
const BAR_PARTS = '[data-widget-area-panel], [data-prompts-panel], [data-widget-gallery], [data-widget-bar-toggle]'

export function isOutsideWidgetBar(target: Element): boolean {
  if (target.closest(BAR_PARTS)) return false
  return !document.querySelector('[role="dialog"][data-state="open"]')
}
